import { Component } from 'react';

import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { EnvironmentService } from '../../../services/environment.service';
import { ExtensionSEOData, RouteProps } from '../../../types/route-types';
import { isEmpty } from '../../../utils/lodash-min';
import styles from './extensions-info.component.module.scss';

export class ExtensionInfoComponent extends Component<RouteProps> {
    extensionSeoDataList: ExtensionSEOData[];
    shouldShowExtensionData = false;

    @lazyInject(IOC_TYPES.EnvironmentService) env: EnvironmentService;

    constructor(props: RouteProps) {
        super(props);
        this.extensionSeoDataList = props.extensionSEOData;
        this.shouldShowExtensionData = !isEmpty(this.extensionSeoDataList) && this.env.isXConvert();
    }

    getContentText(textDataObj: { text: string }, key: number) {
        return <div key={`${key}`} dangerouslySetInnerHTML={{ __html: textDataObj.text }}>
        </div>
    }

    getContentTextLink(textDataObj: { text: string, link: string }, key: number) {
        return <div key={`${key}`}>
            <a href={textDataObj.link} dangerouslySetInnerHTML={{ __html: textDataObj.text }}>
            </a>
        </div>
    }

    getExtensionHTML() {
        return this.extensionSeoDataList.map((extensionSeoData, index) => {
            return (
                <div key={`${index}`}>
                    {!isEmpty(extensionSeoData.extension) && (
                        <div>
                            <h4>
                                More About {extensionSeoData.extension[0].text}{" "}
                                Files
                            </h4>
                            <table className={styles['extension-table']}>
                                <thead>
                                    <tr>
                                        <td>Topic</td>
                                        <td>Description</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        !isEmpty(extensionSeoData.extension) && <tr>
                                            <td>Extension</td>
                                            <td>
                                                {(extensionSeoData.extension || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }

                                    {
                                        !isEmpty(extensionSeoData.category) && <tr>
                                            <td>Details</td>
                                            <td>
                                                {(extensionSeoData.category || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }

                                    {
                                        !isEmpty(extensionSeoData.description) && <tr>
                                            <td>Description</td>
                                            <td>
                                                {(extensionSeoData.description || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }


                                    {
                                        !isEmpty(extensionSeoData.actions) && <tr>
                                            <td>Actions</td>
                                            <td>
                                                {(extensionSeoData.actions || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }

                                    {
                                        !isEmpty(extensionSeoData.details) && <tr>
                                            <td>Details</td>
                                            <td>
                                                {(extensionSeoData.details || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }

                                    {
                                        !isEmpty(extensionSeoData.developer) && <tr>
                                            <td>Developed By</td>
                                            <td>
                                                {(extensionSeoData.developer || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }

                                    {
                                        !isEmpty(extensionSeoData.mime) && <tr>
                                            <td>Mime Type</td>
                                            <td>
                                                {(extensionSeoData.mime || []).map(this.getContentText)}
                                            </td>
                                        </tr>
                                    }

                                    {
                                        !isEmpty(extensionSeoData.links) && <tr>
                                            <td>Links</td>
                                            <td>
                                                {(extensionSeoData.links || []).map(this.getContentTextLink)}
                                            </td>
                                        </tr>
                                    }

                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            );
        });
    }

    render() {
        return (
            <div className={`${this.shouldShowExtensionData ? 'section' : ''}`}>
                {this.shouldShowExtensionData && this.getExtensionHTML()}
            </div>
        );
    }
}
